import React from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import Pricing from '../components/Pricing';
import SEO from '../components/SEO';
import { faqTranslations } from '../utils/i18n';

const MainPage = ({ onPlanSelect, selectedPlan, isAuthenticated }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language || 'ru';
  const title = t('header.title');
  const vpnMatch = title.match(/^(.*?)(?:\s+)?vpn$/i);
  const heroTitleMain = vpnMatch ? vpnMatch[1].trim() : title;
  const hasVpnWord = /\bvpn\b/i.test(title);

  return (
    <>
      <SEO
        title="Diamond VPN — быстрый и безопасный VPN"
        description="Diamond VPN — высокоскоростной VPN‑сервис для обхода блокировок и защиты трафика. Без сложных настроек, с удобным пробным периодом и удобной оплатой."
        ogImage="https://diamondvpn.online/preview.jpg"
      />
      <div className="main-content" data-aos="fade-up">
        {/* Hero */}
        <div className="hero" data-aos="fade-up">
          <div className="logo-section">
            <img src="/images/BLUE.png" alt="Diamond VPN logo" className="logo-icon" />
            <h1 className="hero-title">
              <span className="hero-title-main">{heroTitleMain}</span>
              {hasVpnWord && <span className="hero-title-accent">VPN</span>}
            </h1>
          </div>
          <p className="description">{t('header.subtitle')}</p>
          <div className="hero-actions">
            <div className="trial-banner" data-aos="fade-up" data-aos-delay="100">
              <div className="trial-content">
                <i className="fas fa-gift"></i>
                <span>{t('trial.banner')}</span>
              </div>
            </div>
            <div className="referral-banner" data-aos="fade-up" data-aos-delay="150">
              <div className="referral-content">
                <i className="fas fa-users"></i>
                <span>{t('referral.banner')}</span>
              </div>
            </div>
          </div>
          <button
            className="btn btn-primary hero-cta"
            onClick={() => navigate('/download')}
          >
            {t('main.cta_start')}
          </button>
        </div>

        {/* Advantages */}
        <section className="advantages" data-aos="fade-up" data-aos-delay="150">
          <h2>{t('main.advantages.title')}</h2>
          <div className="advantages-grid">
            <div className="adv-card">
              <div className="adv-icon">
                <i className="fas fa-tachometer-alt"></i>
              </div>
              <h3>{t('main.advantages.speed.title')}</h3>
              <p>{t('main.advantages.speed.desc')}</p>
            </div>
            <div className="adv-card">
              <div className="adv-icon">
                <i className="fas fa-user-secret"></i>
              </div>
              <h3>{t('main.advantages.privacy.title')}</h3>
              <p>{t('main.advantages.privacy.desc')}</p>
            </div>
            <div className="adv-card">
              <div className="adv-icon">
                <i className="fas fa-magic"></i>
              </div>
              <h3>{t('main.advantages.simplicity.title')}</h3>
              <p>{t('main.advantages.simplicity.desc')}</p>
            </div>
            <div className="adv-card">
              <div className="adv-icon">
                <i className="fas fa-server"></i>
              </div>
              <h3>{t('main.advantages.stability.title')}</h3>
              <p>{t('main.advantages.stability.desc')}</p>
            </div>
          </div>
        </section>

        {/* Pricing */}
        <section className="pricing-section" data-aos="fade-up" data-aos-delay="200">
          <Pricing onPlanSelect={onPlanSelect} selectedPlan={selectedPlan} isAuthenticated={isAuthenticated} />
        </section>

        {/* FAQ */}
        <section className="faq" data-aos="fade-up" data-aos-delay="250">
          <h2>{t('main.faq.title')}</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>{t('main.faq.q1_title')}</h3>
              <p>{t('main.faq.q1_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q2_title')}</h3>
              <p>{t('main.faq.q2_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q3_title')}</h3>
              <p>{t('main.faq.q3_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q4_title')}</h3>
              <p>{t('main.faq.q4_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q5_title')}</h3>
              <p>{t('main.faq.q5_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q6_title')}</h3>
              <p>{t('main.faq.q6_text')}</p>
            </div>
            <div className="faq-item">
              <h3>{t('main.faq.q7_title')}</h3>
              <p>{t('main.faq.q7_text')}</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default MainPage;
